import * as React from "react";
import { forwardRef } from "react";
const SvgIconSearchWhite = ({
  title,
  titleId,
  ...props
}, ref) => <svg className="icon" width={18} height={18} viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="none" fillRule="evenodd"><path d="M0 0h18v18H0z" /><g transform="translate(1 1)" stroke="#cccccc" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}><circle cx={5.565} cy={5.565} r={5.565} /><path d="M9.5 9.5 16 16" /></g></g></svg>;
const ForwardRef = forwardRef(SvgIconSearchWhite);
export { ForwardRef as ReactComponent };